import { getRecord, inputBaseInfo, shiftDone, print } from '@/api/accounting';
export default {
  namespaced: true,
  state: {
    record: null,
    showShift: false,
  },

  getters: {
    getRecord: (state) => state.record,
    getShowShift: (state) => state.showShift,
  },

  mutations: {
    SET_RECORD(state, data) {
      state.record = data;
    },
    SET_SHOW_SHIFT(state, data) {
      state.showShift = data;
    },
    RESET(state) {
      state.record = null;
      state.showShift = false;
    },
  },

  actions: {
    //取得帳務資料
    async doGetRecord({ commit }, data) {
      const res = await getRecord(data);
      commit('SET_RECORD', res);
      return Promise.resolve();
    },
    //交班
    async doShift(context, data) {
      const res = await inputBaseInfo(data);
      return Promise.resolve(res);
    },
    //交班完成
    async shiftComplete({ dispatch }) {
      await shiftDone();
      await dispatch('system/doGetDutySection', '', { root: true });
      return Promise.resolve();
    },
    //列印報表
    async printReport(context, data) {
      await print(data);
      return Promise.resolve();
    },
  },
};
